/**
 * goToChannelsClassic action.
 */
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

/**
 * Function to redirect to the classic channel page.
 */
export default function goToChannelsClassic() {
  const { channels } = store.getState();
  const firstChannel = channels.channelsData?.[0];
  store.dispatch(
    pushRoute({
      route: { Page: Pages.CHANNELS_CLASSIC, overwrite: true },
      params: {
        current: {
          channelId: firstChannel?.id,
        },
        stack: {
          stacked: false,
        },
        push: false,
      },
    })
  );
}
